<template>
  <article class="article-ariane">
    <div class="step-line" :style="lineStyle"></div>
    <div
      v-for="(stepItem, index) in steps"
      :key="index"
      class="step"
      :class="{
        selected: stepItem.id === selectedStepId,
        done: stepItem.id < selectedStepId,
      }"
    >
      <div class="circle-btn">
        <p class="step-number">{{ stepItem.id }}</p>
      </div>
      <p class="step-name">{{ $t(`buckets.steps.${stepItem.title}`) }}</p>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
    },
    selectedStepId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    lineStyle() {
      let percent = 0;
      if (this.steps.length) {
        percent = (100 * (this.selectedStepId - 1)) / this.steps.length;
      }
      return {
        background: `linear-gradient(to right, ${this.colors.blue}, ${percent}%, ${this.colors.primary})`,
      };
    },
  },
};
</script>

<style lang="scss" src="./Ariane.scss" scoped></style>
